/* global navigator */

export const capitalize = (
  [first, ...rest],
  locale = navigator.language
) => (first === undefined ? '' : first.toLocaleUpperCase(locale) + rest.join(''))

export const equals = (string1, string2) => `${string1}` === `${string2}`

export const shorten = (string, length) => (string.length > length ? `${string.slice(0, length - 3)}...` : string)

export const truncateMiddle = (string, length, options = {}) => {
  const safeString = string || ''
  const {
    preserveExtension = false,
    tailLength = 3
  } = options

  if (!safeString || safeString.length <= length) {
    return safeString
  }

  const ellipsis = '...'
  const safeTailLength = Math.max(tailLength, 0)

  if (!preserveExtension) {
    const headLength = Math.max(length - ellipsis.length - safeTailLength, 1)
    const tail = safeString.slice(-Math.min(safeTailLength, safeString.length - headLength))

    return `${safeString.slice(0, headLength)}${ellipsis}${tail}`
  }

  const extensionIndex = safeString.lastIndexOf('.')
  const hasExtension = extensionIndex > 0 && extensionIndex < safeString.length - 1

  if (!hasExtension) {
    const headLength = Math.max(length - ellipsis.length - safeTailLength, 1)
    const tail = safeString.slice(-Math.min(safeTailLength, safeString.length - headLength))

    return `${safeString.slice(0, headLength)}${ellipsis}${tail}`
  }

  const extension = safeString.slice(extensionIndex)
  const basename = safeString.slice(0, extensionIndex)
  const maxTailLength = Math.min(safeTailLength, Math.max(basename.length - 1, 0))
  const headLength = Math.max(length - ellipsis.length - extension.length - maxTailLength, 1)
  const tail = basename.slice(-maxTailLength)

  return `${basename.slice(0, headLength)}${ellipsis}${tail}${extension}`
}

export const toSnakeCase = string => string.replace(/([A-Z])/g, $1 => `_${$1.toLowerCase()}`)

export const toHash = string => {
  // Simple 16-character hex hash (not cryptographically secure)
  let hash = 5381
  for (let i = 0; i < string.length; i += 1) {
    hash = (hash * 33 + string.charCodeAt(i)) % Number.MAX_SAFE_INTEGER
  }
  let hex = Math.abs(hash).toString(16)

  // Pad or trim to 16 characters
  if (hex.length < 16) {
    hex = hex.padStart(16, '0')
  } else if (hex.length > 16) {
    hex = hex.slice(-16)
  }

  return hex
}
